export enum PRINT_MODE {
  FRONT = 0,
  FRONT_BACK = 1,
}
